import { components } from './components'
import { globals } from './globals'

export const main = {
  ...globals,
  ...components
}
